import { gql } from '@apollo/client';
import {
  SH_MATCH_PLAYER_FRAGMENT,
  SH_MATCH_FRAGMENT,
  SH_MATCH_SNAPSHOTS_FRAGMENT,
  ERROR_FRAGMENT,
} from './fragments.js';

export const GET_SH_MATCH_BY_RESERVATION = gql`
  query GetShMatchByReservation($reservationId: ID!) {
    MDB {
      id
      _SH_ {
        id
        matchByReservation(reservationId: $reservationId) {
          ...ShMatchFields
        }
      }
    }
  }
  ${SH_MATCH_FRAGMENT}
`;

export const GET_SH_MATCHES_PAGINATED = gql`
  query GetShMatchesPaginated(
    $fieldId: ID
    $status: [_SH_MatchStatus!]
    $from: Date
    $to: Date
    $page: Int
    $limit: Int
  ) {
    MDB {
      id
      _SH_ {
        id
        matches(
          fieldId: $fieldId
          status: $status
          from: $from
          to: $to
          page: $page
          limit: $limit
        ) {
          items {
            id
            reservationId
            structureId
            token
            status
            title
            sportType
            startAt
            endAt
            durationMinutes
            result
            reservationStatus
            reservationPaid
            reservationIsLession
            organizer {
              name
              email
            }
            ...ShMatchSnapshotsFields
            players {
              id
              team
              position
              name
              paid
            }
          }
          pageInfo {
            currentPage
            totalPages
            totalItems
            hasNextPage
            hasPreviousPage
          }
        }
      }
    }
  }
  ${SH_MATCH_SNAPSHOTS_FRAGMENT}
`;

export const UPDATE_SH_MATCH = gql`
  mutation UpdateShMatch($id: ID!, $input: _SH_UpdateMatchInput!) {
    _SH_updateMatch(id: $id, input: $input) {
      ok
      error {
        ...ErrorFields
      }
      match {
        id
        status
        title
        notes
        metadata
        result
        updatedAt
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const UPSERT_SH_MATCH_PLAYER = gql`
  mutation UpsertShMatchPlayer($input: _SH_MatchPlayerInput!) {
    _SH_upsertMatchPlayer(input: $input) {
      ok
      error {
        ...ErrorFields
      }
      player {
        ...ShMatchPlayerFields
      }
    }
  }
  ${SH_MATCH_PLAYER_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const REMOVE_SH_MATCH_PLAYER = gql`
  mutation RemoveShMatchPlayer($matchId: ID!, $team: Int!, $position: Int!) {
    _SH_removeMatchPlayer(matchId: $matchId, team: $team, position: $position) {
      ok
      error {
        ...ErrorFields
      }
    }
  }
  ${ERROR_FRAGMENT}
`;

export const SET_SH_MATCH_PLAYER_ROLE = gql`
  mutation SetShMatchPlayerRole($matchId: ID!, $playerId: ID!, $role: _SH_MatchPlayerRole!) {
    _SH_setMatchPlayerRole(matchId: $matchId, playerId: $playerId, role: $role) {
      ok
      error {
        ...ErrorFields
      }
      player {
        ...ShMatchPlayerFields
      }
    }
  }
  ${SH_MATCH_PLAYER_FRAGMENT}
  ${ERROR_FRAGMENT}
`;

export const MATCH_UPDATED_SUBSCRIPTION = gql`
  subscription MatchUpdated($clientId: String!, $matchId: ID) {
    _SH_matchUpdated(clientId: $clientId, matchId: $matchId) {
      id
      status
      title
      notes
      result
      updatedAt
    }
  }
`;

export const MATCH_PLAYER_UPDATED_SUBSCRIPTION = gql`
  subscription MatchPlayerUpdated($clientId: String!, $matchId: ID!) {
    _SH_matchPlayerUpdated(clientId: $clientId, matchId: $matchId) {
      ...ShMatchPlayerFields
    }
  }
  ${SH_MATCH_PLAYER_FRAGMENT}
`;

export const MATCH_PLAYER_REMOVED_SUBSCRIPTION = gql`
  subscription MatchPlayerRemoved($clientId: String!, $matchId: ID!) {
    _SH_matchPlayerRemoved(clientId: $clientId, matchId: $matchId) {
      id
      matchId
      team
      position
    }
  }
`;
